<template>
	<c-dialog ref="dialog" mode="slide" width="80vw" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="order.order_no" class="m-detail-tag flex-center-cross">
				<label>{{order.order_no}}</label>
				<c-state tag async dict="SALES_ORDER_STATE" :value="order.order_state"></c-state>
			</div>
		</template>

		<module v-if="order.order_no">
			<module-col size="400">
				<c-detail class="m-detail-form">
					<c-detail-item label="销售单号">
						{{order.order_no || '-'}}
					</c-detail-item>
					<c-detail-item v-if="orderType == 2" label="三方订单号">
						{{order.third_party_order_no || order.order_no || '-'}}
					</c-detail-item>
					<c-detail-item v-if="orderType == 2" label="三方质检码">
						{{order.third_party_quality_code || '-'}}
					</c-detail-item>
					<c-detail-item v-if="orderType == 2" label="销售渠道">
						{{order.channel_name || '-'}}
					</c-detail-item>
					<c-detail-item v-if="orderType == 1" label="客户">
						{{order.customer_name || '-'}}
					</c-detail-item>
					<c-detail-item label="订单状态">
                        <c-state async dict="SALES_ORDER_STATE" :value="order.order_state"></c-state>
					</c-detail-item>
					<c-detail-item label="收货人">
						{{order.receiver_name || '-'}}　{{order.receiver_phone || ''}}
					</c-detail-item>
					<c-detail-item label="收货地址">
						{{order.receiver_address || '-'}}
					</c-detail-item>
					<c-detail-item label="快递信息">
						{{order.express_company || '-'}}　{{order.express_no || ''}}
					</c-detail-item>
					<c-detail-item label="订单总金额">
						{{formatPrice(order.total_amount)}}
					</c-detail-item>
					<c-detail-item label="已付款金额">
						{{formatPrice(order.paid_amount)}}
					</c-detail-item>
					<c-detail-item label="退款信息">
						<span v-if="!Number(order.refund_amount)">-</span>
						<div v-else class="m-product-info">
							<p style="color: #e53e3e;">{{formatPrice(order.refund_amount)}}</p>
							<p class="m-product-info-code">{{order.refund_date || '-'}}</p>
						</div>
					</c-detail-item>
					<c-detail-item v-if="orderType == 2" label="预期结算金额">
						{{formatPrice(order.expect_settle_amount)}}
					</c-detail-item>
					<c-detail-item v-if="orderType == 2" label="结算状态">
						<c-state async dict="SALE_SETTLE_STATE" :value="order.settle_state"></c-state>
					</c-detail-item>
					<c-detail-item label="付款时间">
						{{order.pay_date || '-'}}
					</c-detail-item>
					<c-detail-item v-if="order.order_type == 1" label="创建人">
						{{order.create_user_realname || '-'}}
					</c-detail-item>
					<c-detail-item label="订单创建时间">
						{{order.create_date || '-'}}
					</c-detail-item>
					<c-detail-item label="备注">
						{{order.remark || '-'}}
					</c-detail-item>
				</c-detail>
			</module-col>

			<module-col tab-type="border-tab">
				<module-tab name="商品明细" enable-flex>
					<div class="m-detail-box">
						<c-table :data="productList" border :paging="false">
							<c-table-column label="产品信息" width="300">
								<template #default="{data}">
                                    <m-product-info :name="data.product_name" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
								</template>
							</c-table-column>
							<c-table-column label="售卖类型" width="90">
								<template #default="{data}">
									<c-state async dict="SALE_SELL_TYPE" :value="data.sell_type"></c-state>
								</template>
							</c-table-column>
							<c-table-column label="拆机项" width="140">
								<template #default="{data}">{{getDismantleText(data.dismantle_items)}}</template>
							</c-table-column>
							<c-table-column label="销售价" width="80">
								<template #default="{data}">
									<span style="color: #e53e3e;">{{formatPrice(data.sale_price)}}</span>
								</template>
							</c-table-column>
							<c-table-column label="成本价" width="80">
								<template #default="{data}">{{formatPrice(data.cost_price)}}</template>
							</c-table-column>
							<c-table-column label="退货标记" width="90">
								<template #default="{data}">
									<span v-if="data.return_flag == 1" style="color: #e53e3e;">已退货</span>
									<span v-else>-</span>
								</template>
							</c-table-column>
						</c-table>
					</div>
				</module-tab>

				<module-tab v-if="order.order_type == 1" name="收款记录" enable-flex>
					<div class="m-detail-box">
						<c-table :data="paymentList" border :paging="false">
							<c-table-column label="收款方式" width="140">
								<template #default="{data}">{{getPayChannelName(data.pay_channel)}}</template>
							</c-table-column>
							<c-table-column label="收款金额" width="120">
								<template #default="{data}">{{formatPaymentAmount(data)}}</template>
							</c-table-column>
							<c-table-column label="付款流水号" min-width="160">
								<template #default="{data}">{{data.pay_transaction_no || '-'}}</template>
							</c-table-column>
							<c-table-column label="转账凭证" width="200">
								<template #default="{data}">
									<c-file v-if="data.pay_voucher_url" :src="data.pay_voucher_url"></c-file>
									<span v-else>-</span>
								</template>
							</c-table-column>
							<c-table-column label="备注" min-width="120">
								<template #default="{data}">{{data.remark || '-'}}</template>
							</c-table-column>
							<c-table-column label="操作人" width="100">
								<template #default="{data}">{{data.create_user_realname || '-'}}</template>
							</c-table-column>
							<c-table-column label="收款时间" width="160">
								<template #default="{data}">{{data.pay_date || '-'}}</template>
							</c-table-column>
						</c-table>
					</div>
				</module-tab>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	export default {
		name: 'saleOrderDetail',

		props: {
			//订单类型 1=线下 2=线上
			orderType: {
				type: [String, Number],
				default: 2
			}
		},

		data() {
			return {
				orderId: '',
				order: {},
				productList: [],
				paymentList: []
			}
		},

		methods: {
			/*********打开抽屉**********/
			open(data = {}) {
				this.orderId = data.orderId;
				this.order = {};
				this.productList = [];
				this.paymentList = [];
				this.$refs.dialog.open({title: this.orderType == 1 ? '线下订单详情' : '线上订单详情'});
				this.loadDetail();
			},

			/*********加载订单详情**********/
			loadDetail() {
				this.request({
					url: this.orderType == 1 ? '/offline/sale/order/detail' : '/online/sale/order/detail',
					data: {
						order_id: this.orderId
					},
					loading: true,
					success: data => {
						this.order = data.order || {};
						this.productList = data.products || [];
						this.paymentList = data.payments || [];
					}
				});
			},

			/*********获取收款方式名称**********/
			getPayChannelName(code) {
				var map = {
					'offline_cash': '现金',
					'offline_qr_code': '收款码',
					'offline_bank_card': '银行转账',
					'credit': '授信支付',
					'wxpay_scan': '微信扫码',
					'alipay_scan': '支付宝扫码'
				};
				return map[code] || code || '-';
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********格式化分为元（支付单金额存的是分）**********/
			formatCent(cent) {
				if (cent === null || cent === undefined || cent === '') return '-';
				return '¥' + (parseFloat(cent) / 100).toFixed(2);
			},

			/*********收款金额（本单已收金额，后端按元下发；没下发时兜底用支付单总额分转元）**********/
			formatPaymentAmount(payment) {
				var amount = payment.trade_amount;
				if (amount !== null && amount !== undefined && amount !== '') {
					return this.formatPrice(amount);
				}
				return this.formatCent(payment.trade_money);
			},

			/*********解析拆机项**********/
			getDismantleText(items) {
				if (!items) return '-';
				try {
					var list = typeof items == 'string' ? JSON.parse(items) : items;
					if (!Array.isArray(list) || !list.length) return '-';
					return list.map(item => item.name || item).join('、');
				} catch (e) {
					return items;
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-detail-tag {
		gap: 8px;
		font-size: 14px;
		font-weight: bold;
	}

	.m-detail-box {
		padding: 10px;
	}
</style>
